/**
 * Cálculo de una línea de pedido. Es el espejo EXACTO de crear_pedido() en la base y sirve solo para
 * mostrar un estimado en el carrito: el importe que vale es el que calcula el servidor al crear el pedido.
 */
export type LineaCalculada = { base: number; iva: number; total: number }

const redondear = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100

export function calcularLinea(precioUnitario: number, cantidad: number, ivaPorcentaje: number, precioIncluyeIva: boolean): LineaCalculada {
  if (precioIncluyeIva) {
    const total = redondear(precioUnitario * cantidad)
    const base = redondear(total / (1 + ivaPorcentaje / 100))
    return { base, iva: redondear(total - base), total }
  }
  const base = redondear(precioUnitario * cantidad)
  const iva = redondear((base * ivaPorcentaje) / 100)
  return { base, iva, total: redondear(base + iva) }
}

/** Suma de varias líneas, con el mismo redondeo por línea que hace el servidor. */
export function sumarLineas(lineas: LineaCalculada[]): LineaCalculada {
  return lineas.reduce(
    (acc, l) => ({ base: redondear(acc.base + l.base), iva: redondear(acc.iva + l.iva), total: redondear(acc.total + l.total) }),
    { base: 0, iva: 0, total: 0 },
  )
}

/** ¿La cantidad cumple el mínimo y el múltiplo de la presentación? */
export function cantidadValida(cantidad: number, minimo: number, multiplo: number): boolean {
  return Number.isInteger(cantidad) && cantidad >= minimo && cantidad % multiplo === 0
}

/** Cantidad válida más cercana hacia arriba (para los botones + y −). */
export function ajustarCantidad(cantidad: number, minimo: number, multiplo: number): number {
  const m = Math.max(1, multiplo)
  const piso = Math.max(minimo, m)
  const redondeada = Math.ceil(cantidad / m) * m
  return Math.max(piso, redondeada)
}
